import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import BigAbout from "../components/BigAbout";

const About = () => {
  return (
    <>
      <Navbar />
      <Hero title={"About"} />
      <BigAbout />
      <Footer />
    </>
  );
};

export default About;
